<template>
  <div class="hello" v-bind:nam="msg">
      <table> 
        <thead>
        <tr>
          <th v-for="hh in kh" v-bind:key="hh">{{ hh }}</th>
        </tr>
      </thead>
        <tbody>
          <tr v-for="(item,key) in kv" v-bind:key="key">
            <th>{{ key }}</th>
            <td v-for=" (i2,ind) in item" v-bind:key="ind">{{ i2 }}</td>
          </tr>
        </tbody>
      </table>
  </div>
</template>
<style >
  body{
    background-color: black;
    color:rgb(18, 255, 49) ;
  }
</style>
<script>
import { ref } from 'vue'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  setup(){
    // 创建WebSocket连接
    var  v=ref("v");
    var kv =ref(null)
    var kh = ref(null)
    function init(){
        var i=0;
        var Open = false;
        let socket = new WebSocket('ws://192.168.1.45:8181/socket');
        // 打开事件
        socket.onopen = function (event) {
            console.log('Connection opened', event);
            socket.send('Hello Server!');
            // 发送消息到服务器
        };

        // 消息事件
        socket.onmessage = function (event) {
            if (Open) {
                v.value=event.data+(i++)
                kv.value=JSON.parse(event.data)
                if(!kh.value&&kv.value)
                for(var vvv in kv.value){ 
                  kh.value =["标识"].concat(Object.keys(kv.value[vvv]));
                  break;}
            }
            Open = true;
        };

        // 错误事件
        socket.onerror = function () {
            Open = false;
        };

        // 关闭事件
        socket.onclose = function () {
            Open = false;
        };
        return socket;
      }
    var soc =   init();
    
    setInterval(function () {
              if(soc&&soc.readyState==soc.OPEN){
                soc.send("reLoad")
              }else{
                soc=init();
              }
            }, 2000)
    return {v,kv,kh}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
